import Vue from 'vue'
import Highcharts from 'highcharts'
import highchartsStock from 'highcharts/modules/stock'
import highchartsBoost from 'highcharts/modules/boost'
import highchartsMore from 'highcharts/highcharts-more'
import HighchartsVue from 'highcharts-vue'

highchartsStock(Highcharts)
highchartsMore(Highcharts)
highchartsBoost(Highcharts)
Vue.use(HighchartsVue)
